/**
 * Expense seed for services pre-selected in the calendar bulk add flow.
 *
 * Same rule as appointment-service-add-edit (incl. salePricePerItem basis and
 * grams winning over quantity):
 *   autoFix off          → 0
 *   autoFix + fixSum > 0 → fixSum
 *   autoFix + no fixSum  → product cost from the recipe
 */
export function seedBulkExpence(service: {
  autoFix?: boolean | null;
  fixSum?: number | string | null;
  serviceProducts?:
    | {
        quantitySum?: number | string | null;
        grSum?: number | string | null;
        product?: {
          salePricePerItem?: number | string | null;
          grPerItem?: number | string | null;
        } | null;
      }[]
    | null;
}): number {
  if (!service?.autoFix) {
    return 0;
  }

  const fixSum = +(service.fixSum ?? 0) || 0;
  if (fixSum > 0) {
    return fixSum;
  }

  return (service.serviceProducts || []).reduce((total, sp) => {
    const perItem = +(sp?.product?.salePricePerItem ?? 0) || 0;
    if (perItem <= 0) {
      return total;
    }

    let price = 0;
    const quantitySum = +(sp?.quantitySum ?? 0) || 0;
    if (quantitySum > 0) {
      price = perItem * quantitySum;
    }
    const grSum = +(sp?.grSum ?? 0) || 0;
    const grPerItem = +(sp?.product?.grPerItem ?? 0) || 0;
    if (grSum > 0 && grPerItem > 0) {
      price = +((perItem / grPerItem) * grSum).toFixed(2);
    }

    return +(total + price).toFixed(2);
  }, 0);
}
